/******************************************************************
 * Archivo : client/src/components/Admin/surveys/SurveyViewer/ViewerResult/ViewerResultContainer.js
 * Proyecto: CB30
 ******************************************************************/

import React from "react";
import { graphql } from "react-apollo";

// Query
import query from "../../../../../queries/fetchViewerSurveyResult";

// Component
import ViewerResult from "./index";

const ViewerResultContainer = props => {

   console.log(
  JSON.stringify(props.data.viewerSurveyResult, null, 2)
);

  if (props.data.loading) {
    return <div className="loader">Cargando encuesta...</div>;
  }

  if (props.data.error) {
    return <div>{props.data.error.message}</div>;
  }

  if (!props.data.viewerSurveyResult) {
    return null;
  }

 return (
  <ViewerResult
    encuesta={props.encuesta}
    resultado={props.data.viewerSurveyResult}
  />
);

};

export default graphql(query, {

  options: props => ({

    variables: {
      id: props.encuesta.surveyResultsId
    }

  })

})(ViewerResultContainer);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/SurveyViewer/ViewerResult/ViewerResultContainer.js